import * as React from 'react';
import { Dispatch } from 'react-redux';

import { Button } from '../Thumbnails/Column/ButtonsPanel/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { removePages } from '../../../containers/Editor/actions';

interface ButtonRemoveSpreadProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonRemoveSpread = ({ isDisabled, dispatch }: ButtonRemoveSpreadProps) => (
	<Button
		iconWidth="16px"
		iconHeight="20px"
		disabled={isDisabled}
		onClick={() => dispatch(removePages())}
	>
		{Utils.getSvgIcon('iconset_uprez_trash')}
	</Button>
);

export default ButtonRemoveSpread;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonRemoveSpread/index.tsx